import { NavLink } from 'react-router-dom';

function SideNavItem(props) {
  const {
    icon, to, title, exact, subtitle, disabled, id,
  } = props;

  if (!disabled) {
    return (
      <NavLink
        id={id}
        exact={exact}
        className="rounded-l-lg side-nav-item flex justify-start gap-5 items-center px-3 md:px-3 xl:px-7 xl:py-7 py-3 md:py-3 -mr-6 z-10 relative"
        to={to}
      >
        <div className="text-2xl lg:text-3xl text-sentric-submenu-icon icon-active">{icon}</div>
        <div className="w-3/4">
          <p className="font-semibold mb-1">{title}</p>
          <p className="text-xs">{subtitle}</p>
        </div>
      </NavLink>
    );
  }

  return (
    <div className="rounded-l-lg flex justify-start gap-5 items-center px-3 py-3 md:px-3 md:py-3 xl:px-7 xl:py-7 z-10 relative">
      <div className="text-2xl lg:text-3xl text-sentric-submenu-icon icon-active">{icon}</div>
      <div className="w-3/4">
        <p className="font-semibold mb-1 text-sentric-table-gray">{title}</p>
        <p className="text-xs text-sentric-table-gray">{subtitle}</p>
      </div>
    </div>
  );
}

export default SideNavItem;
